import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const CachePage = lazy(() =>
  import('@/features/cache/components/CachePage').then((m) => ({ default: m.CachePage })),
);

export const cacheRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/cache',
  component: CachePage,
});
